// ============================================================================
// KpiSummary.jsx — Corelia UI v1.2
// Badge KPI avec palette InfoPanel + cohérence typographique
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";

const KpiSummary = ({
  kpis = [],             // [{ label, value, color }]
  color = "white",       // palette globale (fallback)
  bordered = true,
  rounded = true,
  style = {},
  itemStyle = {},
}) => {

  const basePalette = theme.InfoPanel[color] || theme.InfoPanel.white;

  const resolvePalette = (kpiColor) =>
    theme.InfoPanel[kpiColor] || basePalette;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing.md,
        marginBottom: theme.spacing.md,
        ...style,
      }}
    >
      {kpis.map((kpi, index) => {
        const palette = resolvePalette(kpi.color);

        return (
          <div
            key={index}
            style={{
              flex: "1 1 140px",
              padding: theme.spacing.md,
              minWidth: 140,
              textAlign: "center",

              // Palette
              backgroundColor: palette.bg,
              color: palette.text,
              border: bordered ? `1px solid ${palette.border}` : "none",
              borderRadius: rounded ? theme.borders.radius.lg : 0,
              boxShadow: theme.shadows.xs,

              // Override éventuel
              ...itemStyle,
            }}
          >
            <div
              style={{
                fontSize: theme.fontSizes.xl,
                fontWeight: theme.fontWeights.semiBold,
                color: palette.title,
                lineHeight: 1.2,
              }}
            >
              {kpi.value}
            </div>

            <div
              style={{
                marginTop: 4,
                fontSize: theme.fontSizes.sm,
                color: palette.text,
                fontFamily: theme.form.label.fontFamily,
              }}
            >
              {kpi.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default KpiSummary;
